export default class DepartmentDevelopers{
    constructor(element){
        this.element = document.querySelector(element);
        if(!this.element) return;
        this.textPanels = Array.from(this.element.querySelectorAll(`${element}__content`));
        this.covers = Array.from(this.element.querySelectorAll(`${element}__cover`));
        this.boxes = this.element.querySelectorAll(`${element}__box`);
        this.loader = this.element.querySelector(`${element}__img-load`);
        this.bindEvents();
        this.init()
    }
    init(){
        this.setActivePanel();
    }
    bindEvents(){
        this.boxes.forEach(box=>{
            box.addEventListener('click', (e)=>this.switchPanel(e));
        })
    }
    setActivePanel(){
        this.textPanels.forEach(panel=>{
            this.animSlideOut(panel, 0);
        });
        this.animSlideIn(this.textPanels[0]);
        this.animSlideIn(this.covers[0]);
        this.boxes[0].classList.add('department-developers__box--active');
    }
    animSlideOut(element, duration = 0.8) {
        TweenMax.to(element, duration, {
            x: -10,
            autoAlpha: 0,
            ease: Power3.easeInOut
        });
    }

    animSlideIn(element, duration = 0.8) {
        TweenMax.set(element, { x: 10 });
        TweenMax.to(element, duration, {
            x: 0,
            autoAlpha: 1,
            ease: Power3.easeInOut
        });

    }
  
    switchPanel(e){
        if(e.currentTarget.classList.contains('department-developers__box--active')) return; // prevent multiple clicks on one item
        let selectedBox = e.currentTarget.dataset.boxId
        let selectedPanel = this.textPanels.filter(item => item.id == selectedBox);
        this.resetItems();
        e.currentTarget.classList.add('department-developers__box--active');
        this.animSlideIn(selectedPanel, 1);
        this.switchBackground(e.currentTarget.dataset.image);
    }
 
    switchBackground(image){
        this.covers.forEach(cover=>{
            this.animSlideOut(cover)
        })
        let selectedImg = this.covers.filter(cover => cover.dataset.image == image);
        this.animSlideIn(selectedImg);
    }
    resetItems(){
        this.textPanels.forEach(panel=>{
            this.animSlideOut(panel);
        })
        this.boxes.forEach(box=>{
            box.classList.remove('department-developers__box--active');
        })
    }
}